var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 2.12C3.51 3.02023 2.78022 3.75 1.88 3.75C0.979776 3.75 0.25 3.02023 0.25 2.12C0.25 1.21978 0.979776 0.490002 1.88 0.490002C2.78022 0.490002 3.51 1.21978 3.51 2.12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 2.12C9.63 3.02023 8.90022 3.75 8 3.75C7.09978 3.75 6.37 3.02023 6.37 2.12C6.37 1.21978 7.09978 0.490002 8 0.490002C8.90022 0.490002 9.63 1.21978 9.63 2.12Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 2.12C15.76 3.02023 15.0302 3.75 14.13 3.75C13.2298 3.75 12.5 3.02023 12.5 2.12C12.5 1.21978 13.2298 0.490002 14.13 0.490002C15.0302 0.490002 15.76 1.21978 15.76 2.12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 7.37C3.51 8.27023 2.78022 9 1.88 9C0.979776 9 0.25 8.27023 0.25 7.37C0.25 6.46978 0.979776 5.74 1.88 5.74C2.78022 5.74 3.51 6.46978 3.51 7.37Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 7.37C9.63 8.27023 8.90022 9 8 9C7.09978 9 6.37 8.27023 6.37 7.37C6.37 6.46978 7.09978 5.74 8 5.74C8.90022 5.74 9.63 6.46978 9.63 7.37Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 7.37C15.76 8.27023 15.0302 9 14.13 9C13.2298 9 12.5 8.27023 12.5 7.37C12.5 6.46978 13.2298 5.74 14.13 5.74C15.0302 5.74 15.76 6.46978 15.76 7.37Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 12.62C3.51 13.5202 2.78022 14.25 1.88 14.25C0.979776 14.25 0.25 13.5202 0.25 12.62C0.25 11.7198 0.979776 10.99 1.88 10.99C2.78022 10.99 3.51 11.7198 3.51 12.62Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 12.62C9.63 13.5202 8.90022 14.25 8 14.25C7.09978 14.25 6.37 13.5202 6.37 12.62C6.37 11.7198 7.09978 10.99 8 10.99C8.90022 10.99 9.63 11.7198 9.63 12.62Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 12.62C15.76 13.5202 15.0302 14.25 14.13 14.25C13.2298 14.25 12.5 13.5202 12.5 12.62C12.5 11.7198 13.2298 10.99 14.13 10.99C15.0302 10.99 15.76 11.7198 15.76 12.62Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 17.87C9.63 18.7702 8.90022 19.5 8 19.5C7.09978 19.5 6.37 18.7702 6.37 17.87C6.37 16.9698 7.09978 16.24 8 16.24C8.90022 16.24 9.63 16.9698 9.63 17.87Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPlaceholder);
export default __webpack_public_path__ + "static/media/company_placeholder.cc2b10ced9bd2cae4a5600079dbbefc1.svg";
export { ForwardRef as ReactComponent };